import { NgModule } from '@angular/core';
import { SecondsToMinutesSecondsPipe } from './seconds-to-minutes-seconds.pipe';
import { MissingValuePipe } from './missing-value.pipe';
import { NoCommaPipe } from './no-comma.pipe';
import { PhonePipe } from './phone.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { ArrayJoinPipe } from './array-join.pipe';
import { TruncateStringPipe } from './truncate-string.pipe';
import { TrustResourceUrlPipe } from './trust-resource-url.pipe';
import { IdDescriptionPipe } from '@edassist-ui/pipes/id-description.pipe';
import { CurrencyConverter } from './currency-converter.pipe';
import { CurrencyPipe } from '@angular/common';

@NgModule({
	exports: [
		SecondsToMinutesSecondsPipe,
		MissingValuePipe,
		NoCommaPipe,
		PhonePipe,
		StripHtmlPipe,
		ArrayJoinPipe,
		TruncateStringPipe,
		TrustResourceUrlPipe,
		IdDescriptionPipe,
		CurrencyConverter
	],
	declarations: [
		SecondsToMinutesSecondsPipe,
		MissingValuePipe,
		NoCommaPipe,
		PhonePipe,
		StripHtmlPipe,
		ArrayJoinPipe,
		TruncateStringPipe,
		TrustResourceUrlPipe,
		IdDescriptionPipe,
		CurrencyConverter
	],
	providers: [CurrencyPipe]
})
class EdAssistUIPipesModule {}

export {
	EdAssistUIPipesModule,
	SecondsToMinutesSecondsPipe,
	MissingValuePipe,
	NoCommaPipe,
	PhonePipe,
	StripHtmlPipe,
	ArrayJoinPipe,
	TruncateStringPipe,
	TrustResourceUrlPipe,
	IdDescriptionPipe,
	CurrencyConverter
};
